<template>
  <div class="related-reading">
    <!-- <div class="normal-title">相关阅读</div> -->
    <titleImg :icon="require('images/qa/questions/real-title.png')" />
    <ul>
      <li class="article-item" v-for="item in articles" :key="item.id">
        <div class="article-item-right">
          <div class="article-title">{{ item.title }}</div>
          <div class="article-info">
            {{ item.author }} · {{ formatNumber(item.viewNum) }}阅读 ·
            {{ formatNumber(item.commentNum) }}评论 ·
            {{ formatNumber(item.zanNum) }}赞
          </div>
        </div>
        <img :src="addOssParamsForcibly(item.cover, 140)" :alt="item.title" />
      </li>
    </ul>
    <div class="show-all">已展示全部</div>
  </div>
</template>

<script>
import { formatNumber } from 'utils/tool.js'
import { addOssParamsForcibly } from 'utils/tool.js'
import titleImg from 'component/qa/title.vue'

export default {
  components: {
    titleImg
  },
  props: {
    articles: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    formatNumber,
    addOssParamsForcibly,
    getToDetailUrl(item) {
      return !this.$platform.isYixinliApp
        ? `https://m.xinli001.com/info/${item.id}`
        : 'javascript:void(0);'
    },
    toDetail(item) {
      if (!this.$platform.isYixinliApp) return true
      let url = `yixinli://open_article?article_id=${item.id}`
      this.routerPush(url)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~lib/scss/functions.scss';

.related-reading {
  background-color: #fff;
  padding: 36px 32px 40px 32px;
  box-sizing: border-box;
  .normal-title {
    font-size: 36px;
    font-weight: 600;
    color: #21252d;
    margin-bottom: 4px;
  }
  .article-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 32px 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    &:last-child {
      border: none;
      padding-bottom: 0;
    }
    img {
      width: 140px;
      height: 140px;
      border-radius: 20px;
      object-fit: cover;
      margin-left: 10px;
    }
    .article-item-right {
      position: relative;
      flex: 1;
      min-width: 0;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      height: 148px;
      &::after {
        position: absolute;
        bottom: -31px;
        content: '';
        width: 100%;
        display: block;
        border-bottom: 1px solid #eaeaea;
      }
      .article-title {
        font-size: 34px;
        font-weight: 600;
        color: #21252d;
        line-height: 50px;
        @include limitLine(2);
        word-wrap: break-word;
      }
      .article-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 26px;
        line-height: 26px;
        font-weight: 400;
        color: #9da3ac;
      }
      // .article-author {
      //   max-width: 180px;
      //   white-space: nowrap;
      //   overflow: hidden;
      //   text-overflow: ellipsis;
      // }
      // .article-num {
      //   white-space: nowrap;
      // }
    }
    &:nth-last-child(1) {
      .article-item-right {
        &::after {
          content: '';
          display: block;
          border: 0 none;
        }
      }
    }
  }
  .line-common {
    content: '';
    display: inline-block;
    width: 60px;
    height: 1px;
    background-color: #eaeaea;
  }
  .show-all {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: #bcc2cf;
    line-height: 24px;
    margin-top: 60px;
    text-align: center;
    &::before {
      @extend .line-common;
      margin-right: 20px;
    }
    &::after {
      @extend .line-common;
      margin-left: 20px;
    }
  }
}
</style>
